const ENV = {

  lupita_url: "https://lup-api.rappi.com/api/landing/",
  lupita_landing_url: "https://lup-api.rappi.com/api/landing/",
  grability_co_url: "https://v2.grability.rappi.com/api/",
  grability_mx_url: "https://v2.mxgrability.rappi.com/api/",
  img_co_url: "https://img.rappi.com/products/medium/",
  img_mx_url: "https://img.rappi.com.mx/products/medium/",
  client_id: "nr7IJTVmdVekFqRFVFHJUiDBT3jIwTrAncSE4ux3",
  client_secret: "o2r4syv0eyhqaSoMryiJqlEUzRDgyRlx4RPGo8NB",
  sinch_secret: "e51c5434-ff42-403e-9557-e95c0caf2c49",
  sinch_url: "https://api.sinch.com/verification/v1/",
  conekta_url: "https://api.conekta.io/tokens",

  getGrabilityHeaders() {
    let headers = {
      'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
      'Content-Type':  'application/json',
    }
    return headers;
  },

  getLupitaHeaders() {
    let country;
    if(localStorage.getItem('country')) {
      country = localStorage.getItem('country')
    } else {
      country = 'co';
    }
    let headers = {
    'Authorization': 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2x1cGl0YS5hdXRoMC5jb20vIiwic3ViIjoiZ29vZ2xlLW9hdXRoMnwxMDA1MjU2ODQ4MjkxNDQyMDM2MTQiLCJhdWQiOiJjZnN5TFl2Z0hfTTlsUW1QN3ZuQnFRYXNaa01Fd1FmSCIsImV4cCI6MTQ5ODYxODQxMSwiaWF0IjoxNDk4NTc1MjExfQ.apHmgCHfsudRkXKNBlVMa_1TZh7SZLTjgQ_nbGCYqks',
    'Content-Type':  'application/json',
    'Country': country
    }
    return headers;
  },

  getSinchHeaders() {
    let regualarDate = new Date();
    let date = regualarDate.toISOString();
    let headers = {
              'Content-Type': 'application/json',
              'Authorization': 'application ' + ENV.sinch_secret ,
              'x-timestamp': date
          }
    return headers;
  },

  getGrabilityUrl() {
   if(localStorage.getItem('country') === 'co') {
      return this.grability_co_url
   } else {
     return this.grability_mx_url
   }
 } ,

 getImageUrl() {
   if(localStorage.getItem('country') === 'co') {
      return this.img_co_url;
   } else {
     return this.img_mx_url;
   }
 },

 getConektaHeaders() {
  let headers = {
     'Content-Type': 'application/json',
     'Authorization': ` Basic a2V5X2Z4ZFlGU05GeFlCWFRDNHNISFhwTkVnOg==`,
     'accept': 'application/vnd.conekta-v0.3.0+json'
  }
  return headers;
 }


}


export default ENV;



// WEBPACK FOOTER //
// ./src/environments/environment.js